<template>
    <div v-if="!isLight">
        <div v-if="!account.is_active">
            <section>
                <h3>{{ $t('account.wireguardTab.expiredTitle') }}</h3>
                <p>{{ $t('account.deviceManagementTab.renewAccount') }}</p>
                <router-link
                    :to="{ name: 'account-' + language }"
                    class="btn btn-solid account-link-spacing"
                    >{{ $t('account.wireguardTab.toYourAccount') }}</router-link
                >
            </section>
        </div>

        <div v-if="account.is_active">

            <section v-if="!isLoaded || inProgress">
                <spinner fill="#398fe6" width="32" height="32" />
            </section>


            <section v-if="!account.device_management">
                <h3>{{ $t('account.deviceManagementTab.disabled') }}</h3>
                <p>{{ $t('account.deviceManagementTab.disabledDesc1') }}</p>
                <p>{{ $t('account.deviceManagementTab.disabledDesc2') }}</p>
                <p>{{ $t('account.deviceManagementTab.disabledDesc3') }} <a href="/knowledgebase/general/device-management-faq/"> {{ $t('account.deviceManagementTab.here') }}</a>.</p>
                <p>{{ $t('account.deviceManagementTab.disabledDesc4') }}</p>
                <a class="btn btn-solid btn-big" @click.prevent="enableDeviceManagement">{{ $t('account.deviceManagementTab.enableDeviceManagement') }}</a>
            </section>

            <section v-if="account.device_management && isLoaded && !inProgress">
                <section v-if="sessions && sessions.length > 0">
                    <h2>{{ $t('account.deviceManagementTab.activeDevices') }}</h2>
                    <p>
                        {{ sessions.length }}/{{ account.product?.max_device }} {{ $t('account.deviceManagementTab.devicesAdded') }} 
                    </p>
                    <div>
                        <device
                            v-for="(device, index) in sessions"
                            :key="index"
                            v-on:deleteDevice="confirmDelete"
                            :name="device.device_name"
                            :token="device.token"
                        ></device>
                    </div>
                    <p class="logout-all">
                        <a @click.prevent="confirmLogoutDevices">{{ $t('account.deviceManagementTab.logoutFromAllDevices') }}</a>
                    </p>
                </section>
            
                <section v-else>
                    <h3>{{ $t('account.deviceManagementTab.enabled') }}</h3>
                    <p>{{ $t('account.deviceManagementTab.enabledDesc1') }}</p>
                    <p>{{ $t('account.deviceManagementTab.please') }} {{ $t('account.deviceManagementTab.login') }} {{ $t('account.deviceManagementTab.enabledDesc2') }}</p>
                </section>

                <section v-if="account.product?.max_device == 2 && sessions && sessions.length > 0">
                    <p>{{ $t('account.deviceManagementTab.increaseDeviceLimit') }} 7 <a :href="'/' + language + '/account/pricing'">{{ $t('account.deviceManagementTab.changeYourProduct') }}</a> {{ $t('account.deviceManagementTab.changeTo') }}</p>
                </section>
            </section>

            <section v-if="account.device_management">
                <a class="btn btn-solid btn-big" href="#" @click="confirmDisableDeviceManagement">{{ $t('account.deviceManagementTab.disableDeviceManagement') }}</a>
            </section>

            <section v-if="account.product?.id === 'IVPN Tier 1' || account.product?.id === 'IVPN Tier 2'">
                <p>{{ $t('account.deviceManagementTab.upgradeText1') }} <a :href="'/' + language + '/account/upgrade'">{{ $t('account.deviceManagementTab.upgradeText2') }}</a> {{ $t('account.deviceManagementTab.upgradeText3') }} </p>
            </section>
        </div>
    </div>
</template>

<script>
import Device from "@/components/Device.vue";
import Spinner from "@/components/ProgressSpinner.vue";

import { mapState } from "vuex";
import { useI18n } from "vue-i18n";

export default {
    components: {
        Device,
        Spinner,
    },
    data() {
        return {
            language: "en"
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (vm.isLight) {
                vm.$router.push('/light');
            } else {
                vm.$store.dispatch("sessions/load");
            }
        });
    },
    mounted() {
        const locale = window.location.href.split("/")[3] || "en";
        useI18n().locale.value = locale;
        this.language = locale;
    },
    computed: {
        ...mapState({
            account: (state) => state.auth.account,
            inProgress: (state) => state.sessions.inProgress,
            isLoaded: (state) => state.sessions.isLoaded,
            sessions: (state) => state.sessions.sessions,
        }),
        isLight() {
            return this.account?.product?.id === 'IVPN Light';
        },
    },
    methods: {
        confirmDelete(data) {
            this.$store.commit("popup/show", {
                type: "delete-device",
                data: data,
            });
        },
        confirmLogoutDevices(data) {
            this.$store.commit("popup/show", {
                type: "logout-devices",
                data: data,
            });
        },
        confirmDisableDeviceManagement(data) {
            this.$store.commit("popup/show", {
                type: "disable-device-management",
                data: data,
            });
        },
        async enableDeviceManagement(){
            await this.$store.dispatch("account/enableDeviceManagement");
            await this.$store.dispatch("sessions/load");
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/styles/buttons.scss" as *;

section {
    position: relative;

    + section {
        margin-top: 40px;
    }
}

p {
    margin-bottom: 24px;
}

ul {
    font-family: $font-main-mono;
    font-size: 16px;
    line-height: 28px;    
}

.logout-all{
    margin-top:20px;
}

.logout-all a{
    color:red;
}

section:last-child {
  margin-bottom: 10px;
}

.account-link-spacing {
    margin-bottom: 20px;
}

</style>